import React from 'react';
import PropTypes from 'prop-types';

import Text from '../../common/Text';
import Locale from '../../Translate';

import './DetailsCardItem.scss';

function DetailsCardItem(props) {
  const { label, children } = props;

  return (
    <React.Fragment>
      <Text as="dt" styleName="label" title>
        <Locale>{label}</Locale>:
      </Text>
      <Text as="dd" styleName="text">
        {children ? children : '-'}
      </Text>
    </React.Fragment>
  );
}

DetailsCardItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default React.memo(DetailsCardItem);
